import React from "react";

const Activities = ({style = {}, size = "36", className = "", fill = "#73788B", viewBox = "0 0 36 36"}) => (
    <svg
        width={size}
        style={style}
        height={size}
        viewBox={viewBox}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={`${className || ""}`}
        xmlnsXlink="http://www.w3.org/1999/xlink"
    >
      <path
          className="u_fill"
          d="M18 27.556h-.135a1.84 1.84 0 01-1.617-1.36l-2.998-10.61-1.987 4.862c-.27.714-.943 1.156-1.718 1.156H3.853c-1.01 0-1.853-.85-1.853-1.87s.842-1.87 1.853-1.87h4.446l3.537-8.706c.303-.748 1.01-1.19 1.819-1.156.775.034 1.448.578 1.684 1.36l3.099 10.984 2.459-5.27a1.764 1.764 0 011.314-1.021c.572-.102 1.179.034 1.583.442l3.806 3.435h4.547c1.01 0 1.853.85 1.853 1.87s-.842 1.87-1.853 1.87h-5.254c-.472 0-.91-.17-1.247-.476l-2.459-2.244-3.503 7.515A1.843 1.843 0 0118 27.556z"
          fill={fill}
      />
    </svg>
);

export default Activities;
